<template>
<div>

    <!-- Single shared header -->
    <section class="section-12" style="position:relative;inset:unset;">
        <div class="div-block-2173 _5step"><img src="@/assets/images/NewSelf_Logo.webp" loading="lazy" sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.png 500w, @/assets/images/NewSelf_Logo-p-800.png 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" class="image-648"></div>
    </section>

    <!-- Step 1: Hero / Get Started -->
    <section class="section_quiz" v-if="active_el === 1">
        <div class="quiz-wrap removePad">
            <div class="glpquiz_div">
                <div data-w-id="152494e0-8119-c24d-56ec-cbcb86819b09" class="quiz_herodiv">
                    <div class="quiz_heroimgdiv hide">
                        <div class="glpquizheroheader">LIFE-CHANGING<br>WEIGHT LOSS MEDICATION</div>
                        <div class="text-block-1603">Get pre-approved for GLP medication with our 3-minute online assessment.</div>
                    </div>
                    <div class="quiz_heroviddiv">
                        <div data-poster-url="https://comnewself.s3.us-east-2.amazonaws.com/public/assets/images/fattothin_color_dark-poster-00001.webp" data-video-urls="https://comnewself.s3.us-east-2.amazonaws.com/public/assets/images/fattothin_color_dark-transcode.mp4,https://comnewself.s3.us-east-2.amazonaws.com/public/assets/images/fattothin_color_dark-transcode.webm" data-autoplay="true" data-loop="true" data-wf-ignore="true" class="background-video-10 w-background-video w-background-video-atom"><video id="92712d6a-272d-29db-a510-112844a8ae35-video" autoplay="true" loop="true" style="background-image:url('https://comnewself.s3.us-east-2.amazonaws.com/public/assets/images/fattothin_color_dark-poster-00001.jpg')" muted="true" playsinline="true" data-wf-ignore="true" data-object-fit="cover">
                                <source src="https://comnewself.s3.us-east-2.amazonaws.com/public/assets/images/fattothin_color_dark-transcode.mp4" data-wf-ignore="true">
                                <source src="https://comnewself.s3.us-east-2.amazonaws.com/public/assets/images/fattothin_color_dark-transcode.webm" data-wf-ignore="true">
                            </video>
                            <div class="vid-text-div">
                                <div class="glpquizheroheader">LIFE-CHANGING<br>WEIGHT LOSS MEDICATION</div>
                                <div class="text-block-1603">Get pre-approved for GLP medication with our 3-minute online assessment.</div>
                            </div>
                        </div>
                    </div>
                    <div class="glp-quiz-button-div">
                        <div class="rx-preview-div"><img src="@/assets/images/NS_Cream_NanoNAD_BlueTilt.webp" loading="lazy" alt=""></div>
                        <div class="rx-preview-div overlap"><img src="@/assets/images/NS_Vial_TirzTilt.webp" loading="lazy" alt=""></div>
                        <div class="rx-preview-div overlap"><img src="@/assets/images/NS_Vial_SemaTilt.webp" loading="lazy" alt=""></div>
                        <a href="#" @click.prevent="handleGetStarted" class="link-block-105 w-inline-block">
                            <div class="text-block-1612">GET STARTED</div>
                            <div class="div-block-2175"><img src="@/assets/images/icon_arrownext.svg" loading="lazy" alt=""></div>
                        </a>
                    </div>
                </div>
                <div data-w-id="f1737dbf-9e11-0949-3790-41c4a681761e" class="disappearing-footer">
                    <div class="text-block-1607">Newself &copy; All rights reserved</div>
                    <div class="text-block-1605">
                        <a href="https://www.newself.com/terms-of-use" target="_blank" class="link-83">Terms of Service </a>&middot; <a href="https://www.newself.com/privacy-policy" target="_blank" class="link-83">Privacy Policy </a>&middot; <a target="_blank" href="https://www.newself.com/telehealth-consent" class="link-83">Telehealth Consent</a>
                    </div>
                    <div class="text-block-1606">Newself is not a laboratory or a medical provider. Results from RX Path may vary.Medication prescriptions are at the discretion of medical providers and may not be suitable for everyone.</div>
                </div>
            </div>
        </div>
    </section>

    <!-- Step 2: Question 1 - Biggest Motivation -->
    <section class="section_quiz" v-if="active_el === 2">
        <div class="quiz-wrap">
            <div class="glpquiz_div" style="grid-row-gap:0;grid-column-gap:0;">
                <div id="quizstep1" class="quizquestiondiv" style="padding-top:20px;">
                    <div class="quizprogress">
                        <div class="quiz-step current">
                            <div class="step-number current">1</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">2</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">3</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">4</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">5</div>
                        </div>
                    </div>
                    <div class="text-block-1604 _5-step">What's Your Biggest Motivation?</div>
                    <div class="w-form">
                        <form>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question1', 'Lose weight or Treat Diabetes')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question1 === 'Lose weight or Treat Diabetes'}">
                                <div>
                                    <div class="text-block-545">Lose weight or Treat Diabetes</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question1', 'Control Appetite')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question1 === 'Control Appetite'}">
                                <div>
                                    <div class="text-block-545">Control Appetite</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question1', 'End Sugar Cravings')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question1 === 'End Sugar Cravings'}">
                                <div>
                                    <div class="text-block-545">End Sugar Cravings</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question1', 'All of the Above')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question1 === 'All of the Above'}">
                                <div>
                                    <div class="text-block-545">All of the Above</div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Step 3: Question 2 - Favorite Part of 100% Online -->
    <section class="section_quiz" v-if="active_el === 3">
        <div class="quiz-wrap">
            <div class="glpquiz_div" style="grid-row-gap:0;grid-column-gap:0;">
                <div id="quizstep2" class="quizquestiondiv" style="padding-top:20px;">
                    <div class="quizprogress">
                        <div class="quiz-step current">
                            <div class="step-number current">1</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">2</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">3</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">4</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">5</div>
                        </div>
                    </div>
                    <div class="text-block-1604">What's Your Favorite Part of 100% Online?</div>
                    <div class="w-form">
                        <form>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question2', 'On-Demand Personalized Treatment')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question2 === 'On-Demand Personalized Treatment'}">
                                <div>
                                    <div class="text-block-545">On-Demand Personalized Treatment</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question2', 'Buying From the Comfort of Home')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question2 === 'Buying From the Comfort of Home'}">
                                <div>
                                    <div class="text-block-545">Buying From the Comfort of Home</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question2', 'Skipping the Long, Expensive Doctor\'s Office')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question2 === 'Skipping the Long, Expensive Doctor\'s Office'}">
                                <div>
                                    <div class="text-block-545">Skipping the Long, Expensive Doctor's Office</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question2', 'All of the Above')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question2 === 'All of the Above'}">
                                <div>
                                    <div class="text-block-545">All of the Above</div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Step 4: Question 3 - Most Important -->
    <section class="section_quiz" v-if="active_el === 4">
        <div class="quiz-wrap">
            <div class="glpquiz_div" style="grid-row-gap:0;grid-column-gap:0;">
                <div id="quizstep-3" class="quizquestiondiv" style="padding-top:20px;">
                    <div class="quizprogress">
                        <div class="quiz-step current">
                            <div class="step-number current">1</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">2</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">3</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">4</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">5</div>
                        </div>
                    </div>
                    <div class="text-block-1604">Let's Match You With the Best Medication - What's Most Important To You?</div>
                    <div class="w-form">
                        <form>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question3', 'Affordability (Lowest Price)')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question3 === 'Affordability (Lowest Price)'}">
                                <div>
                                    <div class="text-block-545">Affordability (Lowest Price)</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question3', 'Potency (Strongest Dose)')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question3 === 'Potency (Strongest Dose)'}">
                                <div>
                                    <div class="text-block-545">Potency (Strongest Dose)</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question3', 'Guided Plan (Personalized Long-Term Treatment)')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question3 === 'Guided Plan (Personalized Long-Term Treatment)'}">
                                <div>
                                    <div class="text-block-545">Guided Plan (Personalized Long-Term Treatment)</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question3', 'All of the Above')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question3 === 'All of the Above'}">
                                <div>
                                    <div class="text-block-545">All of the Above</div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Step 5: Question 4 - How Soon -->
    <section class="section_quiz" v-if="active_el === 5">
        <div class="quiz-wrap">
            <div class="glpquiz_div" style="grid-row-gap:0;grid-column-gap:0;">
                <div id="quizstep4" class="quizquestiondiv" style="padding-top:20px;">
                    <div class="quizprogress">
                        <div class="quiz-step current">
                            <div class="step-number current">1</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">2</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">3</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">4</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step">
                            <div class="step-number">5</div>
                        </div>
                    </div>
                    <div class="text-block-1604 larger">How soon do you want to start achieving your goals with GLP-1s?</div>
                    <div class="w-form">
                        <form>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question4', 'ASAP - I\'m ready to start now')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question4 === 'ASAP - I\'m ready to start now'}">
                                <div>
                                    <div class="text-block-545"><strong>ASAP </strong>- I'm ready to start now</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question4', 'Soon - Not the right time just yet')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question4 === 'Soon - Not the right time just yet'}">
                                <div>
                                    <div class="text-block-545"><strong>Soon </strong>- Not the right time just yet</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question4', 'Not Sure - I\'m still deciding')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question4 === 'Not Sure - I\'m still deciding'}">
                                <div>
                                    <div class="text-block-545"><strong>Not Sure</strong> - I'm still deciding</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleOptionSelectionAndAdvance('question4', 'Need More Info')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question4 === 'Need More Info'}">
                                <div>
                                    <div class="text-block-545">Need More Info</div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Step 6: Question 5 - Currently Taking GLP -->
    <section class="section_quiz" v-if="active_el === 6">
        <div class="quiz-wrap">
            <div class="glpquiz_div" style="grid-row-gap:0;grid-column-gap:0;">
                <div id="quizstep-5" class="quizquestiondiv" style="padding-top:20px;">
                    <div class="quizprogress">
                        <div class="quiz-step current">
                            <div class="step-number current">1</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">2</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">3</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">4</div>
                        </div>
                        <div class="dotted-line"></div>
                        <div class="quiz-step current">
                            <div class="step-number current">5</div>
                        </div>
                    </div>
                    <div class="text-block-1604">Are you currently taking a GLP-1 medication?</div>
                    <div class="w-form">
                        <form>
                            <a href="#" @click.prevent="handleFinalSelection('No, I am not currently taking GLP Medication')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question5 === 'No, I am not currently taking GLP Medication'}">
                                <div>
                                    <div class="text-block-545">No, I am not currently taking GLP Medication</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleFinalSelection('Semaglutide')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question5 === 'Semaglutide'}">
                                <div>
                                    <div class="text-block-545">Semaglutide</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleFinalSelection('Tirzepatide')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question5 === 'Tirzepatide'}">
                                <div>
                                    <div class="text-block-545">Tirzepatide</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleFinalSelection('Mounjaro')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question5 === 'Mounjaro'}">
                                <div>
                                    <div class="text-block-545">Mounjaro</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleFinalSelection('Ozempic')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question5 === 'Ozempic'}">
                                <div>
                                    <div class="text-block-545">Ozempic</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleFinalSelection('Wegovy')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question5 === 'Wegovy'}">
                                <div>
                                    <div class="text-block-545">Wegovy</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleFinalSelection('Zepbound')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question5 === 'Zepbound'}">
                                <div>
                                    <div class="text-block-545">Zepbound</div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleFinalSelection('Other GLP Medication')" class="link-block-copy w-inline-block" :class="{'selected': quizAnswers.question5 === 'Other GLP Medication'}">
                                <div>
                                    <div class="text-block-545">Other GLP Medication</div>
                                </div>
                            </a>
                            
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Step 7: Quiz Footer / Results -->
    <section id="quiz-footer" class="quiz-footer" v-if="active_el === 7">
        <div class="bottom-wrap-copy">
            <div class="glp-quiz-footer-div-copy">
                <div class="footer-hero-copy">
                    <div class="bottom-header-div">
                        <div class="bottom-header-text-copy _1-line">Good News, We Can Help!</div>
                        <div class="div-block-2313">
                            <div>
                                <div class="text-block-1802"><strong>New Patient</strong></div>
                                <div class="text-block-1802">Discount!</div>
                            </div>
                            <div class="div-block-2317">
                                <div class="bottom-price-text-copy"><span class="text-span-448">$249.97</span></div>
                                <div class="div-block-2315">
                                    <div class="text-block-1805">As low as</div>
                                    <div class="div-block-2316">
                                        <div class="bottom-price-text-copy">$84</div>
                                        <div class="div-block-2314">
                                            <div class="text-block-1804">99</div>
                                            <div class="text-block-1803">A month</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="div-block-2312 hide"><img src="@/assets/images/Payment_Methods.webp" loading="lazy" sizes="(max-width: 1440px) 100vw, 1440px, 100vw" srcset="@/assets/images/582995ca4d6b93323fea51fc64b4f27b_Payment_Methods-p-500.webp 500w, @/assets/images/582995ca4d6b93323fea51fc64b4f27b_Payment_Methods-p-800.webp 800w, @/assets/images/582995ca4d6b93323fea51fc64b4f27b_Payment_Methods-p-1080.webp 1080w, @/assets/images/Payment_Methods.webp 1440w" alt="" class="bottom-pay-icons"></div>
                    </div>
                </div>
                <div class="inclusion-boxes-div">
                    <div class="inclusion-box hilite">
                        <div class="inc-flex">
                            <div class="box-icon-div"><img src="@/assets/images/icon_-RX-black.svg" loading="lazy" alt=""></div>
                            <div class="inc-text-div full">
                                <div class="text-block-1800">All Dosages the Same Low Price</div>
                                <div class="text-block-1801">We don't charge you based on dosage changes</div>
                            </div>
                        </div>
                    </div>
                    <div class="inclusion-box">
                        <div class="inc-flex">
                            <div class="box-icon-div"><img src="@/assets/images/icon_doc.svg" loading="lazy" alt=""></div>
                            <div class="inc-text-div">
                                <div class="text-block-1800">Doctor Support <span class="text-span-450">with<br>Health Concierge</span></div>
                            </div>
                            <div class="inc-price-text-div">
                                <div class="text-block-1800-copy"><span class="text-span-449">$99</span> FREE</div>
                            </div>
                        </div>
                    </div>
                    <div class="inclusion-box">
                        <div class="inc-flex">
                            <div class="box-icon-div"><img src="@/assets/images/icon_shipping.svg" loading="lazy" alt=""></div>
                            <div class="inc-text-div">
                                <div class="text-block-1800"><span class="text-span-450">Express</span> Shipping</div>
                            </div>
                            <div class="inc-price-text-div">
                                <div class="text-block-1800-copy"><span class="text-span-449">$99</span> FREE</div>
                            </div>
                        </div>
                    </div>
                    <div class="inclusion-box">
                        <div class="inc-flex">
                            <div class="box-icon-div"><img src="@/assets/images/icon_nopay_blk.svg" loading="lazy" alt="" class="no-pay"></div>
                            <div class="inc-text-div">
                                <div class="text-block-1800">Never Pay <span class="text-span-450">Monthly<br>Membership or App Fees</span></div>
                            </div>
                            <div class="inc-price-text-div">
                                <div class="text-block-1800-copy"><span class="text-span-449">$99</span> FREE</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="tp-rating-div">
                            <div class="div-block-2309">
                                <div class="trustpilot-rating-text-copy">Excellent</div>
                                <div class="text-block-1796-copy">4.5</div>
                                <div class="score-text-copy">out of 5</div>
                            </div>
                            <div class="div-block-2310"><img src="@/assets/images/Trustpilot_Logo_2022.svg.webp" loading="lazy" sizes="(max-width: 2560px) 100vw, 2560px" srcset="@/assets/images/Trustpilot_Logo_2022.svg-p-500.png 500w, @/assets/images/Trustpilot_Logo_2022.svg-p-800.png 800w, @/assets/images/Trustpilot_Logo_2022.svg-p-1080.png 1080w, @/assets/images/Trustpilot_Logo_2022.svg.webp 2560w" alt="" class="trustpilot-rating-logo">
                                <div class="trust-pilot-mobile-div-copy">
                                    <div class="trust-pilot-code-embed w-embed">
                                        <!--  TrustBox widget - Pop-Up  -->
                                        <div class="trustpilot-widget" data-locale="en-US" data-template-id="5418015fb0d04a0c9cf721f2" data-businessunit-id="68b065d56ad677c356e83828" data-style-height="30px" data-style-width="100%" data-token="cef789bd-4856-4b49-82f4-7de3c7b5d12b" data-stars="1,2,3,4,5" data-review-languages="en">
                                            <a href="https://www.trustpilot.com/review/newself.com" target="_blank" rel="noopener">Trustpilot</a>
                                        </div>
                                        <!--  End TrustBox widget  -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a href="#" @click.prevent="finishQuiz" class="button-166-copy w-button">FINISH MY PRE-APPROVAL NOW</a>
                <div class="bottom-footer-div">
                    <div class="text-block-1611-copy">Newself &copy; All rights reserved</div>
                    <div class="text-block-1605-copy">
                        <a href="https://www.newself.com/terms-of-use" target="_blank" class="bottom-links-copy">Terms of Service </a>&middot; <a href="https://www.newself.com/privacy-policy"  target="_blank" class="bottom-links-copy">Privacy Policy </a>&middot; <a target="_blank" href="https://www.newself.com/telehealth-consent" class="bottom-links-copy">Telehealth Consent</a>
                    </div>
                    <div class="bottom-disclosure-copy">Newself is not a laboratory or a medical provider. Results from RX Path may vary. Medication prescriptions are at the discretion of medical providers and may not be suitable for everyone.</div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import { offerQuery } from '@/utils/freeNadLifeOffer.js';

// This quiz is its own funnel, so its step numbering starts at 1 and its events
// carry form "glp1_v3". The checkout it hands off to keeps its own "glp1_v2"
// numbering — the two are separate funnels to the ad platforms.
const TRACKING_FORM = 'glp1_v3';

// Ordered event list. funnel_step is the position in this array, so the numbers
// stay unique and stay in screen order without being typed out one at a time.
const TRACKING_FUNNEL_EVENTS = [
    'questionnaire_start',
    'motivation',
    'online_preference',
    'most_important',
    'start_timing',
    'prior_medications',
    'questionnaire_end'
];

// One event per question screen, named after the question the shopper answered.
const TRACKING_QUESTION_EVENTS = {
    question1: 'motivation',          // What's Your Biggest Motivation?
    question2: 'online_preference',   // What's Your Favorite Part of 100% Online?
    question3: 'most_important',      // What's Most Important To You?
    question4: 'start_timing',        // How soon do you want to start?
    question5: 'prior_medications'    // Are you currently taking a GLP-1 medication?
};

export default {
    name: 'glpQuizFiveSteps',
    data() {
        return {
            active_el: 1,
            // Events already sent. Selecting an option waits 200ms before advancing,
            // so a shopper can tap twice inside that window and would otherwise send
            // the same question event twice.
            trackedEvents: [],
            quizAnswers: {
                question1: '',
                question2: '',
                question3: '',
                question4: '',
                question5: ''
            }
        }
    },
    methods: {
        trackFunnelEvent(name) {
            const index = TRACKING_FUNNEL_EVENTS.indexOf(name);
            if (!window.tracking || index === -1 || this.trackedEvents.includes(name)) return;
            try {
                window.tracking.event(name, { funnel_step: index + 1, form: TRACKING_FORM });
                this.trackedEvents.push(name);
            } catch (error) {
                console.log(error);
            }
        },
        // This page is the front of the funnel, so the session is asserted here
        // before anything else reports. Screen 1 is the hero, so the questionnaire
        // starts when the shopper taps Get Started and question 1 appears.
        async startQuestionnaire() {
            if (!window.tracking || this.trackedEvents.includes('questionnaire_start')) return;
            try {
                await window.tracking.assertSession();
                this.trackFunnelEvent('questionnaire_start');
            } catch (error) {
                console.log(error);
            }
        },
        handleGetStarted() {
            this.startQuestionnaire();
            this.active_el = 2;
        },
        handleOptionSelectionAndAdvance(questionKey, answer) {
            this.quizAnswers[questionKey] = answer;
            // Report as the shopper answers, not in one batch at the end, so the
            // drop-off between questions is visible.
            this.trackFunnelEvent(TRACKING_QUESTION_EVENTS[questionKey]);
            setTimeout(() => {
                this.active_el++;
            }, 200);
        },
        handleFinalSelection(answer) {
            this.quizAnswers.question5 = answer;
            this.trackFunnelEvent(TRACKING_QUESTION_EVENTS.question5);
            setTimeout(() => {
                this.active_el = 7;
            }, 200);
        },
        finishQuiz() {
            // The results screen between question 5 and this button is the first
            // place a price is shown, so it is a real drop-off point. Ending the
            // questionnaire on this tap rather than on question 5 keeps that
            // drop-off measurable, and marks the handoff to the /glp1-v2 checkout.
            this.trackFunnelEvent('questionnaire_end');
            const medication = this.quizAnswers.question5;
            // Capture the med answer for the checkout (harmless if unused), then always
            // send the customer to the /glp1-v2 checkout regardless of what they picked.
            if (medication && medication !== 'No, I am not currently taking GLP Medication') {
                try {
                    localStorage.setItem('preform_glp_data', JSON.stringify({
                        currentlyTakingGLP: 'Yes',
                        currentGLPMed: medication
                    }));
                } catch (e) {
                    // ignore — quota or disabled storage
                }
            }
            // A lander's offer link (?offer=…&nad=…) rides along to the checkout.
            this.$router.push({ path: '/glp1-v2', query: offerQuery(this.$route.query) });
        }
    },
    watch: {
        active_el(newVal) {
            window.scrollTo(0, 0);
            if (newVal === 7) {
                this.$nextTick(() => {
                    const trustboxes = document.querySelectorAll('.trustpilot-widget');
                    if (window.Trustpilot) {
                        trustboxes.forEach(el => window.Trustpilot.loadFromElement(el, true));
                    }
                });
            }
        }
    }
}
</script>

<style scoped>
.link-block-copy.selected {
    background-color: #c9e8ff !important;
    opacity: .9;
}
@media (max-width: 479px) {
    .div-block-2173 {
        padding: 15px 10px 15px !important;
    }
    .quiz_heroviddiv, .background-video-10 {
        height: calc(100vh - 310px);
    }
    .glpquiz_div {
        min-height: calc(100vh - 60px);
        padding-bottom: 0 !important;
        justify-content: space-between !important;
        grid-row-gap: 0 !important;
    }
    .disappearing-footer{
        position: static;
        margin-top: auto;
        width: 100%;
    }
}

</style>
